<template>
  <div class="edit-profile-wrap" :class="{ mobile: mobile }">
    <input
      @change="selectFile"
      type="file"
      ref="file-input"
      style="display: none;"
    />

    <div class="edit-profile-heading" :class="{ mobile: mobile }">
      <span class="left">{{ $t('profile.editProfileInfo') }}</span>
      <div @click="closeEdit">
        <span>{{ $t('chat.closeChat') }}</span>
        <span class="material-icons">close</span>
      </div>
    </div>
    <div class="edit-profile-content-wrap" :class="{ mobile: mobile }">
      <div class="left-content">
        <div class="image-wrapper">
          <span class="title">{{ $t('profile.profilePhoto') }}</span>
          <div class="image-wrap" v-if="!isCroppieOpen">
            <div
              class="avatar"
              @mouseenter="showOverlay = true"
              @mouseleave="showOverlay = false"
            >
              <transition name="overlay-fade">
                <div class="image-overlay" v-if="showOverlay">
                  <span
                    class="material-icons"
                    @click="
                      isCroppieOpen = true
                      showOverlay = false
                    "
                  >
                    add_photo_alternate
                  </span>
                  <div></div>
                  <span class="material-icons" @click="deleteImage">
                    delete_forever
                  </span>
                </div>
              </transition>
              <img :src="usrImage" v-if="usrImage" />
            </div>
          </div>
          <div class="image-wrap" v-else>
            <vue-croppie
              ref="croppieRef"
              :enableResize="false"
              :boundary="{ width: 200, height: 200 }"
              :viewport="{ width: 200, height: 200, type: 'square' }"
            />
            <div class="buttons-holder">
              <button @click="selectImage">
                {{ $t('profile.selectImage') }}
              </button>
              <button @click="crop(true)" v-if="imageIsLoaded">
                {{ $t('button.upload') }}
              </button>
              <button
                @click="
                  isCroppieOpen = false
                  showOverlay = false
                "
              >
                {{ $t('button.cancel') }}
              </button>
            </div>
          </div>
        </div>
        <div class="data-wrapper">
          <span class="title">{{ $t('profile.basicInfo') }}</span>
          <input
            type="text"
            v-model="userData.name"
            maxlength="50"
            :placeholder="$t('profile.firstName')"
          />
          <input
            type="text"
            v-model="userData.lastname"
            maxlength="50"
            :placeholder="$t('profile.lastName')"
          />
          <!-- <input type="text" v-model="userData.email" placeholder="Email" /> -->
        </div>
        <div class="data-wrapper">
          <span class="title">{{ $t('adminAgenda.location') }}</span>
          <input
            type="text"
            v-model="userData.city"
            ref="city"
            maxlength="50"
            :placeholder="$t('register.city')"
          />
          <v-select
            type="select"
            v-model="selectedCNT"
            v-if="countries"
            :options="countries"
            :placeholder="$t('register.country')"
          />
        </div>
      </div>
      <div class="right-content">
        <div class="horisontal-data-wrapper">
          <div class="data-wrapper">
            <span class="title">{{ $t('profile.education') }}</span>
            <input
              type="text"
              v-model="userData.uni_name"
              maxlength="80"
              :placeholder="$t('profile.uniName')"
            />
            <input
              type="text"
              v-model="userData.uni_field"
              maxlength="40"
              :placeholder="$t('profile.studyField')"
            />
            <input
              type="text"
              v-model="userData.grad_year"
              maxlength="4"
              :placeholder="$t('profile.graduationYear')"
            />
          </div>
          <div class="data-wrapper">
            <span class="title">{{ $t('profile.work') }}</span>
            <input
              type="text"
              v-model="userData.company_name"
              maxlength="80"
              :placeholder="$t('profile.nameOfCompany')"
            />
            <input
              type="text"
              v-model="userData.company_title"
              maxlength="40"
              :placeholder="$t('profile.titleInCompany')"
            />
            <input
              type="text"
              v-model="userData.year_started"
              maxlength="4"
              :placeholder="$t('profile.yearStarted')"
            />
          </div>
        </div>
        <div class="data-wrapper">
          <span class="title">{{ $t('profile.shortBio') }}</span>
          <textarea
            :placeholder="$t('profile.shortBio')"
            maxlength="400"
            v-model="userData.bio"
          ></textarea>
        </div>
        <div class="data-wrapper" style="margin-top: 20px;">
          <span class="title">{{ $t('profile.passwordChange') }}</span>
          <input
            type="password"
            :placeholder="$t('profile.currentPassword')"
            maxlength="100"
            v-model="password.current"
          />
          <input
            type="password"
            :placeholder="$t('adminUserManagement.newPassword')"
            maxlength="100"
            v-model="password.new"
          />
          <input
            type="password"
            :placeholder="$t('adminUserManagement.confirmNewPassword')"
            maxlength="100"
            v-model="password.newC"
          />
          <div class="change-password">
            <button @click="changePassword">
              {{ $t('button.changePassword') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-profile-toolbar" :class="{ mobile: mobile }">
      <div class="destructive-btns">
        <div class="delete-button">
          <button @click="deleteProfile">{{ $t('button.delete') }}</button>
        </div>
        <div class="delete-button">
          <button @click="deleteData">{{ $t('button.deleteData') }}</button>
        </div>
      </div>

      <div class="cancel-save-buttons">
        <button @click="closeEdit">{{ $t('button.cancel') }}</button>
        <button @click="uploadData">
          {{ $t('profile.saveChanges') }}
          <span>+</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import isMobileMixin from '../../mixins/isMobileMixin'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      countries: null,
      selectedCNT: null,
      userData: {
        name: '',
        lastname: '',
        // email: "",
        city: '',
        country: '',
        bio: '',
        uni_name: '',
        uni_field: '',
        grad_year: '',
        company_name: '',
        company_title: '',
        year_started: '',
      },
      password: {
        current: '',
        new: '',
        newC: '',
      },
      additionalInfo: null,
      isCroppieOpen: false,
      showOverlay: false,
      avatar: null,
      usrImage: null,
      imageIsLoaded: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    mobile() {
      return this.isMobile
    },
  },
  props: {
    profileid: Number,
  },
  mixins: [isMobileMixin],
  methods: {
    async init() {
      this.getImg()
      await this.fetchProfile()
      this.getCountries()
    },
    async fetchProfile() {
      try {
        let res = await api.getProfile(this.profileid)
        this.trasnformApiData(res.data.user)
      } catch (error) {
        this.handleError(error)
      }
    },
    trasnformApiData(data) {
      let dataOther = data.usr_other ? JSON.parse(data.usr_other) : {}
      this.userData = {
        name: data.firstname,
        lastname: data.usr_lastname,
        // email: data.email,
        city: data.city,
        country: data.country,
        bio: data.bio,
        uni_name: dataOther.uni_name,
        uni_field: dataOther.uni_field,
        grad_year: dataOther.grad_year,
        company_name: dataOther.company_name,
        company_title: dataOther.company_title,
        year_started: dataOther.year_started,
      }
    },
    async getImg() {
      let usrId = localStorage.getItem('usr_id')
      this.usrImage = await this.getImageUsrId(usrId)
    },
    addAdditionalInfo(obj) {
      this.additionalInfo = {
        usr_other: obj,
      }
    },
    selectImage() {
      this.$refs['file-input'].click()
    },
    selectFile(e) {
      const fr = new FileReader()
      fr.onload = (e) => {
        this.isCropping = true
        this.$nextTick(() => {
          this.$refs.croppieRef.bind({
            url: e.target.result,
          })
        })
      }
      fr.readAsDataURL(e.target.files[0])
      this.imageIsLoaded = true
    },
    async crop(sendInfo) {
      await this.$refs.croppieRef.result(
        {
          type: 'blob',
          format: 'jpeg',
        },
        async (result) => {
          await this.uploadImage(result, sendInfo)
        },
      )
    },
    deleteImage() {
      let obj = {
        okButton: this.$t('button.delete'),
        title: this.$t('profile.deleteImageQuestion'),
        okCallback: this.deleteImageLogic,
      }
      this.EventBus.$emit('confirm', obj)
    },
    async deleteImageLogic() {
      this.startLoading()
      try {
        await api.deleteImages(this.profileid)
        this.usrImage = await this.getImageUsdId(null)
      } catch (error) {
        this.handleError(error)
      }
      this.stopLoading()
    },
    async uploadImage(blob, sendInfo) {
      this.startLoading()
      try {
        let fd = new FormData()
        fd.append('image', blob)
        fd.append('usr_id', this.profileid)
        let res = await api.uploadProfileImage(fd)
        let id = res.data.column[0].id
        this.usrImage = await this.getImageUsdId(id)
        this.isCroppieOpen = false
        this.imageIsLoaded = false
      } catch (error) {
        this.handleError(error)
      }
      if (sendInfo) {
        let infoObj = {
          message: this.$t('profile.imageUploadSuccessMessage'),
        }
        this.EventBus.$emit('info', infoObj)
      }
      this.stopLoading()
    },
    closeEdit() {
      this.$emit('close')
    },
    async changePassword() {
      if (this.password.new !== this.password.newC) {
        this.EventBus.$emit(
          'error',
          new Error(this.$t('profile.newPassDontMatch')),
        )
        return
      }
      let obj = {
        old_pass: this.password.current,
        new_pass: this.password.new,
      }
      if (this.profileid) obj.usr_id = this.profileid
      try {
        await api.changePasword(obj)
      } catch (error) {
        this.handleError(error)
        return
      }
      let infoObj = {
        message: this.$t('login.passwordChanged'),
      }
      this.password = {
        current: '',
        new: '',
        newC: '',
      }
      this.EventBus.$emit('info', infoObj)
    },
    async uploadData() {
      // uploads photo if selected
      if (this.imageIsLoaded) await this.crop()
      let dataOther = {
        uni_name: this.userData.uni_name,
        uni_field: this.userData.uni_field,
        grad_year: this.userData.grad_year,
        company_name: this.userData.company_name,
        company_title: this.userData.company_title,
        year_started: this.userData.year_started,
      }
      console.log(this.userData.country)
      let data = {
        // usr_birthdate: this.userData.
        // cnt_id: this.userData.country,
        // usr_socnet
        basic: {
          usr_firstname: this.userData.name,
          usr_lastname: this.userData.lastname,
          // usr_email: this.userData.email,
          usr_city: this.userData.city ? this.userData.city : null,
          cnt_id: this.selectedCNT ? this.selectedCNT.code : null,
          usr_bio: this.userData.bio,
          usr_other: JSON.stringify(dataOther),
        },
      }
      if (this.profileid) {
        data.usr_id = this.profileid
      }
      this.startLoading()
      try {
        await api.updateProfile({ data })
        this.closeEdit()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.stopLoading()
      }
      let infoObj = {
        message: this.$t('profile.profileSavedMessage'),
      }
      this.EventBus.$emit('info', infoObj)
    },
    deleteProfile() {
      let obj = {
        okButton: this.$t('button.delete'),
        title: this.$t('profile.deleteAccoutQuestion'),
        okCallback: this.deleteLogic,
      }
      this.EventBus.$emit('confirm', obj)
    },
    deleteData() {
      let obj = {
        okButton: this.$t('button.delete'),
        title: this.$t('profile.deleteProfileData'),
        okCallback: this.deleteDataLogic,
      }
      this.EventBus.$emit('confirm', obj)
    },
    async deleteDataLogic() {
      this.startLoading()
      try {
        const res = await api.deleteUserData({ data: true })
        this.$router.push({ name: 'Home' })
      } catch (error) {
        this.handleError(error)
      } finally {
        this.stopLoading()
      }
    },
    async deleteLogic() {
      this.startLoading()
      try {
        await api.deleteProfile(this.profileid)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.stopLoading()
      }
      let infoObj = {
        message: this.$t('profile.profileDeletedSuccessMessage'),
      }
      this.EventBus.$emit('info', infoObj)
      this.EventBus.$emit('logout')
    },
    async getCountries() {
      try {
        const result = await api.getCountries()
        if (result.data.countries) {
          let countries = result.data.countries
          this.countries = countries.map((item) => {
            if (item.name === this.userData.country) {
              this.selectedCNT = {
                label: item.name,
                code: item.id,
              }
            }
            return {
              label: item.name,
              code: item.id,
            }
          })
        }
      } catch (error) {
        this.handleError(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
@mixin flex-evenly {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
button:focus {
  outline: none;
}
.edit-profile-wrap {
  padding: 10px 20px;
  z-index: 51;
  position: absolute;
  top: 50%;
  left: 100px;
  width: 1000px;
  height: 80vh;
  min-width: 300px;
  transform: translate(0, -50%);
  background: white;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  &.mobile {
    position: fixed;
    width: 90%;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .edit-profile-heading {
    width: 100%;
    height: 40px;
    position: relative;
    color: #6f6f6f;
    @include flex-between();
    .left {
      font-weight: 900;
    }
    div {
      @include flex-end();
      cursor: pointer;
      span:first-child {
        margin-right: 5px;
      }
      span:nth-child(2) {
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  .edit-profile-heading::after {
    position: absolute;
    bottom: 0px;
    content: '';
    width: 100%;
    height: 1px;
    background-color: #bdbdbd;
  }
  .edit-profile-content-wrap {
    &.mobile {
      .left-content {
        flex-grow: 1;
        padding: 20px 0 0 0;
        margin-right: 15px;
        height: unset;
      }
      .right-content {
        padding-left: 0px;
        max-width: 400px;
        padding-top: 0;
        margin-right: 15px;
        height: unset;
        flex-grow: 1;
        .horisontal-data-wrapper {
          flex-wrap: wrap;
          .data-wrapper {
            width: 100%;
          }
        }
      }
    }
    @include flex-between();
    flex-wrap: wrap;
    width: 100%;
    padding-top: 5px;
    height: calc(100% - 100px);
    box-sizing: border-box;
    overflow: auto;
    .title {
      margin-bottom: 7px;
      width: 100%;
      opacity: 0.7;
    }
    .left-content {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      width: 30%;
      min-width: 260px;
      max-width: 400px;
      height: calc(100% - 20px);
      padding: 20px 30px 0 0;
      overflow: auto;

      .image-wrapper {
        width: 100%;
      }
      span {
        width: 100%;
        text-align: start;
      }
      .image-wrap {
        @include flex-center();
        flex-direction: column;
        overflow: hidden;
        position: relative;
        width: 100%;
        .avatar {
          width: 100%;
          img {
            height: 100%;
            width: 100%;
          }
          .image-overlay {
            @include flex-center();
            width: 100%;
            height: calc(100% - 4px);
            position: absolute;
            background: rgba(255, 255, 255, 0.283);
            border-radius: 10px;
            div {
              height: 80px;
              width: 2px;
              background: white;
            }
            span {
              user-select: none;
              cursor: pointer;
              color: white;
              font-size: 35px;
              width: 40px;
              height: 40px;
              margin: 0 5px;
            }
          }
          border-radius: 10px;
          overflow: hidden;
        }
        .buttons-holder {
          width: 100%;
          @include flex-between();
          button {
          }
        }
      }
      .data-wrapper {
        width: 100%;
        margin: 10px 0;
        input {
          width: 100%;
          margin: 0 0 8px;
          outline: none;
        }
      }
    }
    .right-content {
      padding: 20px 0px;
      height: calc(100% - 40px);
      width: 65%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      overflow: auto;

      .horisontal-data-wrapper {
        width: 100%;
        @include flex-between();
        flex-wrap: wrap;
        .data-wrapper {
          width: 45%;
          margin: 10px 0;
          input {
            width: 100%;
            margin: 0 0 8px;
            outline: none;
          }
        }
      }
      input:focus {
        outline: none;
      }
      .data-wrapper {
        width: calc(100% - 22px);
        textarea::placeholder {
          font-family: 'Roboto';
        }
        textarea:focus {
          outline: none;
        }
        textarea {
          margin-top: 10px;
          border: 1px solid #dadada;
          resize: none;
          width: 100%;
          height: 100px;
          line-height: 20px;
          border-radius: 10px;
          padding: 10px;
        }
        input {
          margin: 10px 0;
        }
        .change-password {
          width: 100%;
          @include flex-end();
          button {
            padding: 0 10px;
            height: 30px;
            cursor: pointer;
            color: white;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            border: none;
            background: #888c8e;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .edit-profile-toolbar {
    .destructive-btns {
      display: flex;
      button {
        margin: 0 10px;
      }
    }
    &.mobile {
      .delete-button {
        button {
          width: 70px;
          font-size: 13px;
          height: 30px;
        }
      }
      .cancel-save-buttons {
        width: 60%;
        button {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 11px;
          flex-basis: 0px;
          height: 30px;
          span {
            font-size: 20px;
            font-weight: 500;
          }
        }
      }
    }
    height: 60px;
    width: 100%;
    @include flex-between();
    .delete-button {
      button {
        cursor: pointer;
        font-weight: 600;
        font-size: 15px;
        color: white;
        background: #ba5757;
        @include flex-evenly();
        width: 150px;
        height: 40px;
        border: none;
        border-radius: 10px;
      }
    }
    .cancel-save-buttons {
      @include flex-evenly();
      width: 350px;
      button:first-child {
        opacity: 0.7;
        margin-right: 10px;
      }
      button {
        cursor: pointer;
        font-weight: 600;
        font-size: 15px;
        color: white;
        @include flex-evenly();
        flex-shrink: 1;
        flex-basis: 150px;
        height: 40px;
        border: none;
        background: #888c8e;
        border-radius: 10px;
        span {
          font-size: 30px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
